import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css'; // Add CSS import
// 导入植物园logo
import plantLogo from '../assets/plant-logo.jpg';

const Header = () => {
  return (
    <header className="app-header">
      <div className="header-container">
        <div className="header-left">
          <Link to="/" className="logo-link">
            <img src={plantLogo} alt="庐山杏林中药植物研究所 Logo" className="logo-image" />
            <div className="site-title">
              <span className="site-title-cn">庐山杏林中药植物研究所</span>
              <span className="site-title-en">LUSHAN XINGLIN INSTITUTE FOR MEDICINAL PLANTS</span>
              <span className="site-title-cn">庐山植物园山南分园</span>
              <span className="site-title-en">Shannan Sub-garden of Lushan Botanical Garden</span>
            </div>
          </Link>
        </div>
        <nav className="main-nav">
          <ul>
            <li>
              <Link to="/">
                <span className="nav-cn">首页</span>
              </Link>
            </li>
            <li>
              <Link to="/garden">
                <span className="nav-cn">杏林花园</span>
              </Link>
            </li>
            <li>
              <Link to="/plants">
                <span className="nav-cn">植物展示</span>
              </Link>
            </li>
            <li>
              <Link to="/visit">
                <span className="nav-cn">参观游览</span>
              </Link>
            </li>
            <li>
              <Link to="/events">
                <span className="nav-cn">近期活动</span>
              </Link>
            </li>
            <li>
              <Link to="/learning">
                <span className="nav-cn">科学教育</span>
              </Link>
            </li>
            <li>
              <Link to="/about-us">
                <span className="nav-cn">关于我们</span>
              </Link>
            </li>
          </ul>
        </nav>
        <div className="header-contact">
          <div className="customer-service">
            <div className="service-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="service-content">
              <div className="service-title">客服热线</div>
              <div className="service-phones">
                <a href="tel:0792-2188999" className="phone-number">0792-2188999</a>
                <span className="or-text">或</span>
                <a href="tel:0792-2199888" className="phone-number">0792-2199888</a>
              </div>
              <div className="service-description">任何问题，我们将及时为您解答</div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;